import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

import { ToasterService } from './toaster/toaster.service';


@Injectable()
export class ErrorHandlerService {

  constructor(
      private toaster: ToasterService
  ) { }

  handle(error: any, tituloDefinidoManualmente?: string) {
    let titulo = '';
    let msg = '';
    let detail: string;
    if (typeof error === 'string') {
      msg += error;
    }
    else if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      console.error('Ocorreu um erro na operação.');
      msg += 'Ocorreu um erro na operação.';
      console.error(error.error.message);
      detail = error.error.message;
    }
    else if (error.name === 'HttpErrorResponse') {

      let mensagemUsuario = '';
      switch (error.status) {
        case 502: // bad gateway
          mensagemUsuario = 'Servidor indisponível';
          break;

        case 500: // internal server error
          mensagemUsuario = 'Ocorreu um erro interno no servidor';
          break;

        case 400: // bad request
          mensagemUsuario = 'Requisição está inválida';
          break;

        case 404: // not found
          mensagemUsuario = 'Serviço/URL não encontrado';
          break;

        case 401: // not authorized
          mensagemUsuario = 'Não autorizado';
          break;

        case 503: // service unavailable
          mensagemUsuario = 'Serviço indisponível';
          break;

        case 408: // request timeout
          mensagemUsuario = 'Sua requisição expirou';
          break;

        case 403: // forbidden
          mensagemUsuario = 'Acesso não permitido';
          break;

        default:
          mensagemUsuario = 'Ocorreu um erro na operação';
          break;
      }
      titulo = mensagemUsuario;
      msg += `${this.getMensagemDeErro(error)}`;
      /*
      if ( error.status ) {
        msg += `${this.getMensagemDeErro(error)}
                <br><br>Erro ${error.status}`;
      }
      else {
        msg += `${this.getMensagemDeErro(error)}`;
      }
      */
    }
    else {
        try {
            if (error.name) {
                titulo = error.name;
            }
            msg += this.getMensagemDeErro(error);
        }
        catch (er) {
            if (msg) { msg += '  '; }
            msg += 'Ocorreu um erro na operação.';
        }
        console.error('Ocorreu um erro na operação.', error);
    }

    if (detail) {
      if (msg) { msg += '  '; }
      msg += '<br><br>Descrição: ' + detail + '';

    }

    // if ( false && error.status === 403 && !environment.production ) {
    //   msg += '     [url: ' + error.url + ']';
    // }

    if ( tituloDefinidoManualmente ) {
      titulo = tituloDefinidoManualmente;
    }

    if ( error.status === 403 ) {
      this.toaster.warning(titulo, msg);
    }
    else {
      this.toaster.error(titulo, msg);
    }

    this.irParaPaginaDeLoginSeTokenExpirou(error);

    return error;
  }

  getMensagemDeErro(error: any): string {
    let msg = '';
    if (error.error && error.error.error_description) {
      if (msg) { msg += '  '; }
      msg += error.error.error_description;
    }
    else if (error.error && error.error[0] && error.error[0].mensagemUsuario) {
      if (msg) { msg += '  '; }
      msg += error.error[0].mensagemUsuario;
    }
    else if (error.error && error.error.message) {
      if (msg) { msg += '  '; }
      msg += error.error.message;
    }
    else if (error.error && (typeof error.error === 'string') ) {
      if (msg) { msg += '  '; }
      msg += error.error;
    }
    else if (error.message) {
      if (msg) { msg += '  '; }
      msg += error.message;
    }
    else {
        if (msg) { msg += '  '; }
        msg += 'Ocorreu um erro na operação.';
    }
    return msg;
  }

  irParaPaginaDeLoginSeTokenExpirou(error: any) {
    let irParaPaginaDeLogin = false;
    
    if ( error.status === 401 ) {
      if ( error.error && error.error.error && error.error.error === 'invalid_token' ) {
        irParaPaginaDeLogin = true;
      }
    }

    // prevenir refresh se estiver na pagina de login
    if ( document.location.href.indexOf(environment.caminho_pagina_login) >= 0 ) { 
      irParaPaginaDeLogin = false;
    }

    if ( irParaPaginaDeLogin ) {
      document.location.href = document.location.origin + environment.caminho_pagina_login;
      // this.appComponent.verificaUsuarioLogado();
    }
  }

}
